/**
 * Keys for the TanStack Query cache. Every cached request gets its key from
 * here so cache updates and invalidations can't drift from the queries.
 *
 * Keys are nested so a prefix matches every variant, e.g. `audiences()`
 * matches every audience list and `audience(id)` every load of one audience.
 */
export const queryKeys = {
  variables: (client: string) => ["variables", client] as const,
  variableSearch: (client: string, term: string) => ["variables", client, "search", term] as const,
  locations: () => ["locations"] as const,
  sites: (client: string) => ["sites", client] as const,
  users: () => ["users"] as const,

  audiences: () => ["audiences"] as const,
  audienceList: (client: string, audienceType: string, demoClient?: string) =>
    ["audiences", client, audienceType, demoClient ?? null] as const,
  audience: (audienceId: string) => ["audience", audienceId] as const,
  audienceDetail: (audienceId: string, audienceType: string, segment: boolean) =>
    ["audience", audienceId, audienceType, segment] as const,

  insight: (audienceId: string) => ["insight", audienceId] as const,
  insightDetail: (audienceId: string, client: string, segment: boolean) =>
    ["insight", audienceId, client, segment] as const,

  activations: (client: string) => ["activations", client] as const,
  activation: (campaignId: string) => ["activation", campaignId] as const,
  activationDetail: (campaignId: string) => ["activation", campaignId, "detail"] as const,
  activationRecipe: (campaignId: string) => ["activation", campaignId, "recipe"] as const,
};
